import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_108: FaireProductEntity = {
  token: "legacy_prod_abbott-108",
  type: "product",
  name: 'Large Sheep on Legs Planter 3" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/48c5fc13c778c6535a0d2e19fb048e91c9de7766be393f902aeacadfd1740576.jpeg",
  priceDollars: 22,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
